var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.canAccess)?[_vm._l((_vm.groups),function(group,index){return [_c('user-listing',{key:group.name,class:{ 'mt-2': index > 0 },attrs:{"group":group}})]})]:_c('no-access')],2)}
var staticRenderFns = []

export { render, staticRenderFns }